import { FirestoreTimestamp } from "../types/shared";

export const isAddedToday = (dateInput: Date | FirestoreTimestamp | string | number | null | undefined): boolean => {
    if (!dateInput) return false;

    let date: Date;
    // Handle Firebase Timestamp
    if (typeof (dateInput as any).toDate === 'function') {
        date = (dateInput as any as FirestoreTimestamp).toDate();
    } else if (dateInput instanceof Date) {
        date = dateInput;
    } else {
        // Try creating a date from string/number
        date = new Date(dateInput as string | number);
    }

    // Check for invalid date
    if (isNaN(date.getTime())) return false;

    const today = new Date();
    return date.getDate() === today.getDate() &&
        date.getMonth() === today.getMonth() &&
        date.getFullYear() === today.getFullYear();
};

/**
 * Returns the local date string in YYYY-MM-DD format.
 * This avoids the UTC offset issue inherent to `new Date().toISOString().split('T')[0]`.
 */
export const getLocalDateString = (date: Date = new Date()): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};
